import httpConnection from "../api/httpconnection";

const headers = {
  "Content-Type": "application/json; charset=utf-8",
};

export async function getConsolidateAgeingReportNew() {
  const response = await httpConnection.get(
    `ageing-report/getConsolidateAgeingReport`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingReportDetailsByRegionNew(
  regionMasterId,
  divisionId,
  asmLoginId,
  moduleType = "All",
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingReportDetailsByRegion?regionMasterId=${regionMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}&moduleType=${moduleType}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingReportDetailsByStateNew(
  stateMasterId,
  divisionId,
  asmLoginId,
  moduleType = "All",
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingReportDetailsByState?stateMasterId=${stateMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}&moduleType=${moduleType}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getConsolidateAgeingReportWithFiltersNew(
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getConsolidateAgeingReportWithFilters?divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingHistoryReportDetailsByRegionNew(
  regionMasterId,
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingHistoryReportDetailsByRegion?regionMasterId=${regionMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingHistoryReportDetailsByStateNew(
  stateMasterId,
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingHistoryReportDetailsByState?stateMasterId=${stateMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getFutureOverDueDetailsByAsmNew(asmLoginId, divisionId) {
  const response = await httpConnection.get(
    `ageing-report/getFutureOverDueDetailsByAsm?asmLoginId=${asmLoginId}&divisionId=${divisionId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingProvisionHistoryReportDetailsByRegionNew(
  regionMasterId,
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingProvisionHistoryReportDetailsByRegion?regionMasterId=${regionMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function getAgeingProvisionHistoryReportDetailsByStateNew(
  stateMasterId,
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingProvisionHistoryReportDetailsByState?stateMasterId=${stateMasterId}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}

export async function exportToExcelAgeingReportNew(
  dateTime,
  mainTabType,
  divisionId,
  asmLoginId,
) {
  try {
    const response = await httpConnection.get(
      `ageing-report/export-to-excel?mainTabType=${mainTabType}&dateTime=${dateTime}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
      {
        responseType: "arraybuffer",
      },
    );
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Ageing_Report_${dateTime}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
}
export async function getAgeingReportDetailsByPaymentClass(
  paymentClass,
  divisionId,
  asmLoginId,
) {
  const response = await httpConnection.get(
    `ageing-report/getAgeingReportDetailsByPaymentClass?paymentClass=${paymentClass}&divisionId=${divisionId}&asmLoginId=${asmLoginId}`,
    {},
    { headers: headers },
  );
  return {
    response: response.data,
  };
}
